import React from "react";
import _ from "lodash";
import styles from "./Analysis.module.scss";

//components
import { DocumentTitle } from "../../components/DocumentTitle";
import { LogoSpinner } from "../../components/LogoSpinner";
import { PageTitle } from "../../components/PageTitle";
import { AnalysisCard } from "../../components/AnalysisCard";

class Analysis extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [
                {
                    title: "Consumption Analysis",
                    description:
                        "This feature provides detailed comparisons of current and previous year's consumption, emissions, and costs, both during and outside of operating hours.",
                    imgsrc: "/img/analysisThumbnails/consumption-analysis.png",
                    type: "energy",
                    disabled: false,
                    link: "/consumption-analysis",
                },
                {
                    title: "Energy Analysis",
                    description:
                        "Track performance of your selected meters over given time periods, in contrast with their respective baselines.",
                    imgsrc: "/img/analysisThumbnails/energy-analysis.png",
                    type: "energy",
                    disabled: false,
                    link: "/energy-analysis",
                }
            ],
            selected_filter: null
        };
    }

    cardClickHandler(link) {
        this.props.history.push("/analysis" + link);
    }

    getCards() {
        const filter = this.state.selected_filter;
        let list = this.state.items;

        if (filter) {
            list = list.filter((db) => {
                return db.type.includes(filter);
            });
        }
        list = _.sortBy(list, "disabled");

        return list.map((db, i) => {
            return (
                <AnalysisCard
                    key={db.title}
                    title={db.title}
                    imgsrc={db.imgsrc}
                    description={db.description}
                    clickHandler={() => this.cardClickHandler(db.link)}
                    disabled={db.disabled}
                />
            );
        });
    }

    selectFilter(filter) {
        const selected_filter = this.state.selected_filter;
        this.setState({
            selected_filter: selected_filter === filter ? null : filter,
        });
    }

    render() {
        return (
            <div
                id="Dashboards"
                className="br-mainpanel br-profile-page floorplan-background"
                style={{ scrollY: "scroll" }}
            >
                <DocumentTitle title="Analysis" />
                <LogoSpinner loading={this.state.loading} />
                <div className="br-container">
                    <div className="row">
                        <div className="col mg-t-30">
                            <PageTitle
                                buttons={[
                                    {
                                        label: "All",
                                        trueCondition: this.state.selected_filter === null,
                                        clickHandler: () => this.selectFilter(null),
                                    },
                                    {
                                        label: "Energy",
                                        trueCondition: this.state.selected_filter === "energy",
                                        clickHandler: () => this.selectFilter("energy"),
                                    },
                                    // {
                                    //     label: "Wellness",
                                    //     trueCondition: this.state.selected_filter === "wellness",
                                    //     clickHandler: () => this.selectFilter("wellness"),
                                    // },
                                ]}
                            />
                        </div>
                    </div>
                    <div className="row mg-t-10">
                        <div className="col">
                            <div className={styles['cardsWrapper']}>
                                {this.getCards()}
                                {/* Empty cards to execute the correct layout */}
                                <AnalysisCard empty />
                                <AnalysisCard empty />
                                <AnalysisCard empty />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Analysis;
